module.exports = __webpack_public_path__ + "static/media/error.43bf11fb.svg";